import { render, staticRenderFns } from "./BizAreaYtdUsage.vue?vue&type=template&id=38c33032&scoped=true"
import script from "./BizAreaYtdUsage.vue?vue&type=script&lang=js"
export * from "./BizAreaYtdUsage.vue?vue&type=script&lang=js"
import style0 from "./BizAreaYtdUsage.vue?vue&type=style&index=0&id=38c33032&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c33032",
  null
  
)

export default component.exports